import { render, staticRenderFns } from "./DocSummary.vue?vue&type=template&id=66eb14f9&scoped=true"
import script from "./DocSummary.vue?vue&type=script&lang=js"
export * from "./DocSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66eb14f9",
  null
  
)

export default component.exports